// extracted by mini-css-extract-plugin
export default {"totalPriceContainer":"Y_50Y4SclOF5024T1q_W","periodContainer":"vc9x5b1hSKRoznvjWYna"};